document.documentElement.classList.remove("no-js");

const body = document.body;
const drawer = document.querySelector("[data-cart-drawer]");
const scrim = document.querySelector("[data-cart-scrim]");
const mobileMenu = document.querySelector("[data-mobile-menu]");
const menuButton = document.querySelector("[data-menu-open]");
let lastFocusedElement = null;

function setBodyLock(locked) {
  body.classList.toggle("range-lock", locked);
}

function openCart() {
  if (!drawer || !scrim) return;
  closeMenu(false);
  lastFocusedElement = document.activeElement;
  drawer.classList.add("is-open");
  drawer.setAttribute("aria-hidden", "false");
  scrim.hidden = false;
  requestAnimationFrame(() => scrim.classList.add("is-visible"));
  setBodyLock(true);
  drawer.querySelector("[data-cart-close]")?.focus();
}

function closeCart(restoreFocus = true) {
  if (!drawer || !scrim) return;
  drawer.classList.remove("is-open");
  drawer.setAttribute("aria-hidden", "true");
  scrim.classList.remove("is-visible");
  window.setTimeout(() => { if (!mobileMenu?.classList.contains("is-open")) scrim.hidden = true; }, 260);
  if (!mobileMenu?.classList.contains("is-open")) setBodyLock(false);
  if (restoreFocus && lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
}

function openMenu() {
  if (!mobileMenu) return;
  closeCart(false);
  lastFocusedElement = document.activeElement;
  mobileMenu.classList.add("is-open");
  mobileMenu.setAttribute("aria-hidden", "false");
  menuButton?.setAttribute("aria-expanded", "true");
  if (scrim) {
    scrim.hidden = false;
    requestAnimationFrame(() => scrim.classList.add("is-visible"));
  }
  setBodyLock(true);
  mobileMenu.querySelector("[data-menu-close]")?.focus();
}

function closeMenu(restoreFocus = true) {
  if (!mobileMenu) return;
  mobileMenu.classList.remove("is-open");
  mobileMenu.setAttribute("aria-hidden", "true");
  menuButton?.setAttribute("aria-expanded", "false");
  if (scrim && !drawer?.classList.contains("is-open")) {
    scrim.classList.remove("is-visible");
    window.setTimeout(() => { if (!drawer?.classList.contains("is-open")) scrim.hidden = true; }, 260);
  }
  if (!drawer?.classList.contains("is-open")) setBodyLock(false);
  if (restoreFocus && lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
}

document.addEventListener("click", async (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  if (target.closest("[data-cart-open]")) openCart();
  if (target.closest("[data-cart-close]")) closeCart();
  if (target.matches("[data-cart-scrim]")) {
    if (drawer?.classList.contains("is-open")) closeCart();
    if (mobileMenu?.classList.contains("is-open")) closeMenu();
  }

  if (target.closest("[data-menu-open]")) openMenu();
  if (target.closest("[data-menu-close]")) closeMenu();

  const thumb = target.closest("[data-gallery-thumb]");
  if (thumb) {
    const root = thumb.closest("[data-product-root]");
    const id = thumb.getAttribute("data-gallery-thumb");
    root?.querySelectorAll("[data-gallery-thumb]").forEach((item) => item.classList.toggle("is-active", item === thumb));
    root?.querySelectorAll("[data-gallery-media]").forEach((item) => item.classList.toggle("is-hidden", item.getAttribute("data-gallery-media") !== id));
  }

  const quickAdd = target.closest("[data-quick-add]");
  if (quickAdd) {
    event.preventDefault();
    quickAdd.setAttribute("disabled", "");
    try {
      await addVariant(quickAdd.getAttribute("data-quick-add"), 1);
      window.location.reload();
    } finally {
      quickAdd.removeAttribute("disabled");
    }
  }

  const changeButton = target.closest("[data-cart-change]");
  if (changeButton) {
    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: changeButton.getAttribute("data-cart-change"),
        quantity: Number(changeButton.getAttribute("data-quantity"))
      })
    });
    window.location.reload();
  }
});

async function addVariant(id, quantity) {
  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
  });
  if (!response.ok) throw new Error("Unable to add product");
  return response.json();
}

document.querySelectorAll("[data-product-root]").forEach((root) => {
  const variants = JSON.parse(root.querySelector("[data-product-json]")?.textContent || "[]");
  const selectedOptions = [];

  root.querySelectorAll("[data-option-index]").forEach((field) => {
    const active = field.querySelector("[data-option-button].is-selected");
    selectedOptions[Number(field.getAttribute("data-option-index"))] = active?.getAttribute("data-option-value");
  });

  function updateVariant() {
    const variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));
    const variantInput = root.querySelector("[data-variant-id]");
    const addButton = root.querySelector("[data-add-to-cart]");
    const addLabel = root.querySelector("[data-add-label]");
    const price = root.querySelector("[data-product-price]");
    if (!variant || !variantInput || !addButton) return;

    variantInput.value = variant.id;
    addButton.disabled = !variant.available;
    if (addLabel) addLabel.textContent = variant.available ? "Add to bag" : "Sold out";
    if (price) price.textContent = Shopify.formatMoney ? Shopify.formatMoney(variant.price) : `$${(variant.price / 100).toFixed(2)}`;
    if (history.replaceState) history.replaceState({}, "", `${location.pathname}?variant=${variant.id}`);
  }

  root.querySelectorAll("[data-option-button]").forEach((button) => {
    button.addEventListener("click", () => {
      const index = Number(button.getAttribute("data-option-index"));
      const value = button.getAttribute("data-option-value");
      selectedOptions[index] = value;
      root.querySelectorAll(`[data-option-button][data-option-index="${index}"]`).forEach((item) => {
        const selected = item === button;
        item.classList.toggle("is-selected", selected);
        item.setAttribute("aria-pressed", selected ? "true" : "false");
      });
      const label = root.querySelector(`[data-option-value="${index}"]:not(button)`);
      if (label) label.textContent = value;
      updateVariant();
    });
  });

  root.querySelector("[data-quantity-minus]")?.addEventListener("click", () => {
    const input = root.querySelector("[data-quantity-input]");
    input.value = Math.max(1, Number(input.value) - 1);
  });
  root.querySelector("[data-quantity-plus]")?.addEventListener("click", () => {
    const input = root.querySelector("[data-quantity-input]");
    input.value = Number(input.value) + 1;
  });

  root.querySelector("[data-product-form]")?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const id = form.querySelector("[data-variant-id]").value;
    const quantity = Number(form.querySelector("[data-quantity-input]").value);
    await addVariant(id, quantity);
    window.location.reload();
  });
});

document.querySelectorAll("product-recommendations").forEach(async (element) => {
  const response = await fetch(element.dataset.url);
  if (!response.ok) return;
  const html = document.createElement("div");
  html.innerHTML = await response.text();
  const recommendations = html.querySelector("product-recommendations");
  if (recommendations?.innerHTML.trim()) element.innerHTML = recommendations.innerHTML;
});

document.querySelectorAll("[data-sort-by]").forEach((select) => {
  select.addEventListener("change", () => select.form?.submit());
});

function trapFocus(event, container) {
  if (event.key !== "Tab") return;
  const focusable = [...container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
    .filter((element) => element instanceof HTMLElement && element.offsetParent !== null);
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

document.addEventListener("keydown", (event) => {
  if (drawer?.classList.contains("is-open")) trapFocus(event, drawer);
  if (mobileMenu?.classList.contains("is-open")) trapFocus(event, mobileMenu);
  if (event.key !== "Escape") return;
  if (drawer?.classList.contains("is-open")) closeCart();
  if (mobileMenu?.classList.contains("is-open")) closeMenu();
});
